package com.islamicmedia.site.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page

/**
 * The product itself, at `/app`.
 *
 * The site ROOT is the marketing landing page — a static file the Dockerfile copies over the
 * export's `index.html` — so the app needs an address of its own. This is where the landing
 * page hands off to (`/app?q=…` for a search, `/app?auth=1` for the Log in button).
 *
 * Deliberately a thin alias rather than moving [Index]'s route: [Index] stays on `/` as well,
 * so a local `./gradlew :site:kobwebStart` — which never runs the Dockerfile's copy step, and
 * so never sees the landing page — still opens straight into the app the way it always has.
 */
@Page("/app")
@Composable
fun AppPage() = Index()
